module.exports = "https://cdn2-fs.clearscore.com/flux/images/47402bb0343952a796904c42843b7747.jpg";